import { Component, OnDestroy, OnInit } from '@angular/core';
import { CapiLoginService } from '../../core/extension/login/capi-login-service';
import { ListLoaderPreloaded } from '../../shared/components/list-loader/list-loader-preloaded';
import { GbgrundstueckService, GrundstueckEigentuemerSearchResponse } from '../../core/gb-api';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { DokulinkItemBuilderFactory } from '../../shared/components/dokulink/dokulinkItemBuilderFactory';
import { keysToTranslate } from '../../../i18n/keys-to-translate';
import { KompaktGrundstueckPipe } from '../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { KompaktGrundstueckbeschreibungPipe } from '../../shared/kompaktdarstellung/grundstueck-beschreibung/kompakt-grundstueckbeschreibung.pipe';
import { GrundstuecknummerPipe } from '../../shared/pipes/simple/grundstuecknummer.pipe';
import {
  GrundstueckIcpListEntryVm,
  MeineGrundstueckeIcpTableComponent
} from './meine-grundstuecke-icp-table/meine-grundstuecke-icp-table.component';
import { GbPrintService } from '../../core/services/app-print.service';
import { TranslateNamePipe } from '../../shared/pipes/simple/translate-name.pipe';
import { AppPermissionService } from '../../core/services/app-permission.service';
import { ArrayAbbreviatePipe } from '../../shared/pipes/simple/array-abbreviate.pipe';
import { DecimalHochkommaPipe } from '../../shared/pipes/simple/decimalHochkomma.pipe';
import { KompaktGebaeudeeingangsadressePipe } from '../../shared/kompaktdarstellung/gebaeudeeingangsadresse/kompakt-gebaeudeeingangsadresse-pipe';
import { FunctionbarComponent } from '../../shared/functionbar/functionbar/functionbar.component';
import { ContentHeaderComponent } from '../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../shared/components/title-functionbar/title-functionbar.component';
import { FormsModule } from '@angular/forms';
import { MetaDisablerDirective } from '../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../shared/directives/meta-validator.directive';
import { CapSpinnerSmallComponent } from '../../shared/components/cap-spinner-small/cap-spinner-small.component';

@Component({
  selector: 'cap-meine-grundstuecke',
  templateUrl: './meine-grundstuecke-icp.component.html',
  styleUrls: ['./meine-grundstuecke-icp.component.scss'],
  imports: [
    FunctionbarComponent,
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    MeineGrundstueckeIcpTableComponent,
    CapSpinnerSmallComponent,
    TranslatePipe
  ]
})
export class MeineGrundstueckeIcpComponent extends AbstractComponent implements OnInit, OnDestroy {
  hasLoggedInUser = false;
  mitAdressen = false;
  filterTerm: string = '';
  grundstueckLoader: ListLoaderPreloaded<GrundstueckIcpListEntryVm>;
  grundstueckSubscription: Subscription;
  grundstueckEigentuemerSearchResponse: GrundstueckEigentuemerSearchResponse;

  constructor(
    protected router: Router,
    private translateService: TranslateService,
    private loginService: CapiLoginService,
    private permissionService: AppPermissionService,
    private gbGrundstueckService: GbgrundstueckService,
    private translateNamePipe: TranslateNamePipe,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe,
    private kompaktGrundstueckBeschreibungPipe: KompaktGrundstueckbeschreibungPipe,
    private kompaktGebaeudeeingangsadressePipe: KompaktGebaeudeeingangsadressePipe,
    private grundstuecknummerPipe: GrundstuecknummerPipe,
    private decimalHochkommaPipe: DecimalHochkommaPipe,
    private abbreviatePipe: ArrayAbbreviatePipe,
    protected gbPrintService: GbPrintService,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory
  ) {
    super();

    keysToTranslate<string>(['KeineDatenVorhanden', 'meineGrundstuecke.titel']);

    this.grundstueckSubscription = this.gbGrundstueckService.loadGrundstueckeForEigentuemer().subscribe({
      next: (response) => {
        this.grundstueckEigentuemerSearchResponse = response;
        const gsList = response.results.map((entry) => {
          return new GrundstueckIcpListEntryVm(entry, {
            translate: this.translateService,
            translateNamePipe: this.translateNamePipe,
            grundstuecknummerPipe: this.grundstuecknummerPipe,
            kompaktGrundstueckBeschreibungPipe: this.kompaktGrundstueckBeschreibungPipe,
            kompaktGrundstueckPipe: this.kompaktGrundstueckPipe,
            kompaktGebaeudeeingangsadressePipe: this.kompaktGebaeudeeingangsadressePipe,
            abbreviatePipe: this.abbreviatePipe,
            decimalHochkommaPipe: this.decimalHochkommaPipe,
            dokuLinkBuilderFactory: this.dokuLinkBuilderFactory
          });
        });
        this.grundstueckLoader = new ListLoaderPreloaded<GrundstueckIcpListEntryVm>(15, 1, gsList, response.recordsFound);
      },
      error: (err) => {
        this.handleError(err);
      }
    });
  }

  ngOnInit(): void {
    this.hasLoggedInUser = this.loginService.userLoggedIn;
    this.mitAdressen = this.permissionService.hasPermission('ICP_AUTHORIZED');
  }

  private handleError(err) {
    throw err;
  }

  ngOnDestroy(): void {
    this.grundstueckSubscription?.unsubscribe();
  }

  clearFilter() {
    this.filterTerm = '';
  }
}
